export default __webpack_public_path__ + "static/media/default.c5675c58fd13bdfaa0773896b50bdec0.png";